<div class="container-fluid">
    <div class="row row justify-content-center">
        <div class="col-12 col-xl-8">
            <h1 class="fs-4 d-flex gap-3 justify-content-center align-items-center">
                <a class="btn btn-sm p-1 small btn-outline-light text-secondary border rounded-3 d-flex" href="/policies">
                    <span class="material-symbols-outlined">arrow_left_alt</span>
                </a>
                <span class="material-symbols-outlined text-colonial fw-light" style="font-size: 40px;"> recent_actors </span>
                Póliza No. {{(policyNumber || '') | mask: policyMask}}
            </h1>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-12 col-xl-8">
            <div class="card shadow-sm border-0 my-3">
                <div class="card-header text-center text-colonial bg-white border-0">
                    <div class="h6 my-2">Datos de la póliza</div>
                </div>
                <div class="card-body p-0">
                    @if (isVehicle) {
                        <app-vehicle-detail [value]="vehiclePolicies" [policy]="policyNumber" [slob]="slob"></app-vehicle-detail>
                    }
                    @else if (isHouse) {
                        <app-house-detail [value]="housePolicies" [policy]="policyNumber"></app-house-detail>
                    }
                    @else {
                        <app-travel-detail [value]="travelPolicies" [policy]="policyNumber"></app-travel-detail>
                    }
                </div>
            </div>
        </div>
    </div>
</div>

